export default class OutboundSAMLQueryStringParameterInput {
    constructor(
        public QueryStringParameterName?: string,
        public SamlAttributeName?: string
    ){}
}